import { RESULT_TYPE } from '@web-platform/shared-universal-constants/src/resultType';
import { isSpecificDate } from '@web-platform/shared-universal-utils-frontend-localisation';

import { isLocationCityOrAirport } from './searchValidation';

import type { DateString } from '@web-platform/shared-universal-types/src/dateString';
import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export const isBananaCombinedResults = (
  destination: SearchLegPlace | undefined,
  origin: SearchLegPlace | undefined,
  outboundDate: DateString | undefined,
): boolean => {
  if (!(destination && origin && outboundDate)) {
    return false;
  }

  if ([origin, destination].every(isLocationCityOrAirport) && isSpecificDate(outboundDate)) {
    return true;
  }

  return false;
};

export const getResultType = (
  destination: SearchLegPlace | undefined,
  origin: SearchLegPlace | undefined,
  outboundDate: DateString | undefined,
) => {
  const isCombinedResults = isBananaCombinedResults(destination, origin, outboundDate);
  return isCombinedResults ? RESULT_TYPE.COMBINED_RESULTS : RESULT_TYPE.COMBINED_EXPLORE;
};
